import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel
} from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
import PropTypes from 'prop-types'

import { classNames } from '../../helpers'

/**
 * Aufklappbarer Abschnitt innerhalb einer Karte.
 *
 * Der Trigger ist bewusst als Bedienelement gestaltet (weisse Flaeche, Rahmen,
 * Hover, Focus-Ring) — die Behandlung entspricht dem Copy-Button des
 * Einladungslinks. Vorher war er von einem Feld-Label nicht zu unterscheiden.
 */
const CollapsibleSection = ({ title, children, defaultOpen, className }) => (
  <Disclosure defaultOpen={defaultOpen}>
    {({ open }) => (
      <div className={classNames('py-6', className)}>
        <DisclosureButton className='flex w-full items-center justify-between gap-2 rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700 transition hover:border-gray-300 hover:text-gray-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primaryBlue'>
          <span>{title}</span>
          <ChevronDownIcon
            aria-hidden='true'
            className={classNames(
              'size-4 flex-shrink-0 text-gray-400 transition-transform',
              open && 'rotate-180'
            )}
          />
        </DisclosureButton>
        <DisclosurePanel
          transition
          className='mt-4 origin-top transition duration-150 ease-out data-[closed]:-translate-y-1 data-[closed]:opacity-0'
        >
          {children}
        </DisclosurePanel>
      </div>
    )}
  </Disclosure>
)

CollapsibleSection.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  defaultOpen: PropTypes.bool,
  className: PropTypes.string
}

CollapsibleSection.defaultProps = {
  defaultOpen: false,
  className: undefined
}

export default CollapsibleSection
